import Text from '@ui/atoms/Text';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import envelopeIllustration from '@public/images/envelope.png';
import styled from 'styled-components';
import Button from '@ui/atoms/Button';
import { useResponsive } from '@hooks/useResponsive';
import useInternalRouteMapping from '@hooks/useInternalRouteMapping.hook';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    align-items: start;
    padding: 1.5rem;
    background-color: var(--primary50);
    border-radius: var(--r-m);
    position: relative;
    overflow: hidden;

    & > p {
        max-width: 37.5rem;
        z-index: 1;
    }
`;

const LinkButton = styled(Button)`
    box-shadow: var(--s-primary);

    ${(props) => props.theme.mediaQueries.mobile} {
        width: 100%;
    }
`;

const Illustration = styled.img`
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%) rotate(-15deg);
    width: 6.8rem;
    height: auto;
    z-index: 0;
`;

const NewsletterDisabled = () => {
    const { isDesktopLarge } = useResponsive();
    const { link } = useInternalRouteMapping();
    const newsletterSettingsLink = link('communication', { tab: 'newsletter' });

    return (
        <Container>
            <Text variant="bodyL" fontWeight="--fw-semibold">
                <FormattedMessage defaultMessage="Activez la Newsletter de votre podcast depuis l'onglet Communication afin de notifier vos auditeurs par e-mail de la sortie de chaque nouvel épisode. 💌" />
            </Text>
            <LinkButton
                forwardedAs="a"
                href={newsletterSettingsLink}
                target="_blank"
                endIcon={
                    <FontAwesomeIcon icon={icon({ name: 'arrow-up-right', style: 'solid' })} />
                }
            >
                <FormattedMessage defaultMessage="Activer les newsletters" />
            </LinkButton>
            {isDesktopLarge && <Illustration src={envelopeIllustration} />}
        </Container>
    );
};

export default NewsletterDisabled;
